import { Page } from '@/components/shared/onboarding-page';
import { PasswordForm } from './PasswordForm';
import { Image } from '@chakra-ui/react';
import SecurityIcon from '@/assets/images/onboarding/security1.png';
import { Center } from '@chakra-ui/react';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { useEffect } from 'react';

export const SetPassword = ({ token = null, onComplete = () => {} }) => {
  const { track } = useMixpanel();
  useEffect(() => {
    track({
      event: 'onboarding.set-password.visited',
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Page>
      <Page.Left>
        <PasswordForm token={token} onComplete={onComplete} />
      </Page.Left>
      <Page.Right>
        <Center
          bg="linear-gradient(6.31deg, #FEF7FD 3.83%, #F8FBF7 49.64%, #EBFBFC 95.45%);"
          borderRadius="8px"
          height="100%"
        >
          <Image src={SecurityIcon} w="340px" height="420px" />
        </Center>
      </Page.Right>
    </Page>
  );
};
